export const translations = {
  pt: {
    // Header Nav
    nav: {
      home: 'Início',
      about: 'Sobre',
      experience: 'Trajetória',
      skills: 'Habilidades',
      projects: 'Projetos',
      certificates: 'Certificados',
      contact: 'Contato'
    },

    // Hero
    hero: {
      greeting: 'Olá, eu sou',
      role: 'Backend Engineer & Software Architect',
      cta: 'Ver Projetos',
      contact: 'Contato'
    },

    // About
    about: {
      title: 'Sobre Mim',
      stats: {
        experience: 'Anos de Experiência',
        projects: 'Projetos Entregues',
        certifications: 'Certificações',
        satisfaction: 'Satisfação'
      }
    },

    // Experience
    experience: {
      title: 'Trajetória',
      education: 'Formação',
      specializations: 'Especializações',
      professional: 'Experiência Profissional',
      current: 'Atual'
    },

    // Skills
    skills: {
      title: 'Habilidades',
      subtitle: 'Tecnologias e ferramentas que domino'
    },

    // Projects
    projects: {
      title: 'Projetos',
      subtitle: 'Alguns dos projetos que desenvolvi',
      viewAll: 'Ver Todos',
      viewCode: 'Código',
      viewDemo: 'Demo',
      completed: 'Concluído',
      inProgress: 'Em Progresso'
    },

    // Certificates
    certificates: {
      title: 'Certificados',
      subtitle: 'Certificações e cursos concluídos',
      viewAll: 'Ver Todos',
      viewCert: 'Ver Certificado'
    },

    // Contact
    contact: {
      title: 'Contato',
      subtitle: 'Vamos trabalhar juntos?',
      name: 'Nome',
      email: 'E-mail',
      subject: 'Assunto',
      message: 'Mensagem',
      send: 'Enviar',
      sendWhats: 'WhatsApp',
      sendEmail: 'E-mail',
      success: 'Mensagem enviada com sucesso!',
      error: 'Erro ao enviar mensagem.'
    },

    // Footer
    footer: {
      quickLinks: 'Links Rápidos',
      contact: 'Contato',
      backToTop: 'Voltar ao Topo',
      rights: 'Todos os direitos reservados.'
    }
  },

  en: {
    nav: {
      home: 'Home',
      about: 'About',
      experience: 'Journey',
      skills: 'Skills',
      projects: 'Projects',
      certificates: 'Certificates',
      contact: 'Contact'
    },

    hero: {
      greeting: "Hi, I'm",
      role: 'Backend Engineer & Software Architect',
      cta: 'View Projects',
      contact: 'Contact'
    },

    about: {
      title: 'About Me',
      stats: {
        experience: 'Years of Experience',
        projects: 'Projects Delivered',
        certifications: 'Certifications',
        satisfaction: 'Satisfaction'
      }
    },

    experience: {
      title: 'Journey',
      education: 'Education',
      specializations: 'Specializations',
      professional: 'Professional Experience',
      current: 'Current'
    },

    skills: {
      title: 'Skills',
      subtitle: 'Technologies and tools I master'
    },

    projects: {
      title: 'Projects',
      subtitle: 'Some of the projects I developed',
      viewAll: 'View All',
      viewCode: 'Code',
      viewDemo: 'Demo',
      completed: 'Completed',
      inProgress: 'In Progress'
    },

    certificates: {
      title: 'Certificates',
      subtitle: 'Certifications and completed courses',
      viewAll: 'View All',
      viewCert: 'View Certificate'
    },

    contact: {
      title: 'Contact',
      subtitle: "Let's work together?",
      name: 'Name',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      send: 'Send',
      sendWhats: 'WhatsApp',
      sendEmail: 'Email',
      success: 'Message sent successfully!',
      error: 'Error sending message.'
    },

    footer: {
      quickLinks: 'Quick Links',
      contact: 'Contact',
      backToTop: 'Back to Top',
      rights: 'All rights reserved.'
    }
  },

  es: {
    nav: {
      home: 'Inicio',
      about: 'Acerca',
      experience: 'Trayectoria',
      skills: 'Habilidades',
      projects: 'Proyectos',
      certificates: 'Certificados',
      contact: 'Contacto'
    },

    hero: {
      greeting: 'Hola, soy',
      role: 'Backend Engineer & Software Architect',
      cta: 'Ver Proyectos',
      contact: 'Contacto'
    },

    about: {
      title: 'Sobre Mí',
      stats: {
        experience: 'Años de Experiencia',
        projects: 'Proyectos Entregados',
        certifications: 'Certificaciones',
        satisfaction: 'Satisfacción'
      }
    },

    experience: {
      title: 'Trayectoria',
      education: 'Formación',
      specializations: 'Especializaciones',
      professional: 'Experiencia Profesional',
      current: 'Actual'
    },

    skills: {
      title: 'Habilidades',
      subtitle: 'Tecnologías y herramientas que domino'
    },

    projects: {
      title: 'Proyectos',
      subtitle: 'Algunos de los proyectos que desarrollé',
      viewAll: 'Ver Todos',
      viewCode: 'Código',
      viewDemo: 'Demo',
      completed: 'Completado',
      inProgress: 'En Progreso'
    },

    certificates: {
      title: 'Certificados',
      subtitle: 'Certificaciones y cursos completados',
      viewAll: 'Ver Todos',
      viewCert: 'Ver Certificado'
    },

    contact: {
      title: 'Contacto',
      subtitle: '¿Trabajamos juntos?',
      name: 'Nombre',
      email: 'Correo',
      subject: 'Asunto',
      message: 'Mensaje',
      send: 'Enviar',
      sendWhats: 'WhatsApp',
      sendEmail: 'Correo',
      success: '¡Mensaje enviado con éxito!',
      error: 'Error al enviar mensaje.'
    },

    footer: {
      quickLinks: 'Enlaces Rápidos',
      contact: 'Contacto',
      backToTop: 'Volver Arriba',
      rights: 'Todos los derechos reservados.'
    }
  }
};
